import React from 'react';
import { _cs } from '@togglecorp/fujs';
import TextOutput from '../TextOutput/index.js';
import { genericMemo } from '../../utils/index.js';
import styles from './styles.css.js';

const spacingToStyleMap = {
  none: styles.noSpacing,
  compact: styles.compactSpacing,
  comfortable: styles.comfortableSpacing,
  loose: styles.looseSpacing
};

function KeyFigure(props) {
  const {
    className,
    label,
    spacing = 'comfortable',
    valueClassName,
    descriptionClassName,
    small,
    value
  } = props;
  return /*#__PURE__*/React.createElement(TextOutput, {
    className: _cs(styles.keyFigure, className, spacingToStyleMap[spacing]),
    value: value,
    valueType: "number",
    valueContainerClassName: _cs(styles.value, small && styles.small, valueClassName),
    descriptionContainerClassName: _cs(styles.description, small && styles.small, descriptionClassName),
    description: label
  });
}

var index = genericMemo(KeyFigure);

export { index as default };
//# sourceMappingURL=index.js.map
